import App from "../../../vendor_core/core/src/App";
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import CommManager from "../../../vendor_core/core/src/controllers/CommManager";
import RequestRegister from "../../../vendor_core/core/src/server/requests/RequestRegister";
import { State } from "../../../vendor_core/core/src/states/State";
import UIController from "../../../vendor_core/core/src/ui/UIController";
import { UIStates } from "../../../vendor_core/core/src/ui/UIStates";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import BBReelGroup from "../view/BBReelGroup";

export default class BBSpinEndState extends State {

    public enter(): void {
        super.enter();
        UIController.setState(UIStates.SPIN_END);
        // ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().containers.get("reels").enableMask();
        this.onResponse();
    }

    protected onResponse() {
        let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as BBReelGroup;
        reelGroup.winSymbolsView.unlockAll();

        App.dispatcher.emit(GameEvents.SPIN_COMPLETE);
        CommManager.send(
            RequestRegister.get("saveRestoreState"),
            () => { },
            this
        );
        this.exit();
    }
}
